// extracted by mini-css-extract-plugin
export default {"container":"style_container__wf+W+","cards":"style_cards__tI1Bl","text":"style_text__a2lWT","mobile":"style_mobile__3GRY7"};